import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { getEoneStList, getPlatfmcodeList, getStInforList, saveB2bPlatform,updateB2bPlatform,editB2bPlatform } from 'Actions/b2bManagement';
import { getSCList } from 'Actions/userCenter';
import { openNotification } from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import { T } from 'Actions/translate';
import util from 'Utils/commonUtil';
import { loadLanguage } from 'Utils/jwtUtil';
import Header from 'Components/common/Header';

class ViewB2bPlatform extends Component {

	state = {
		loading: false,
        platformData:[]
	}

   async componentDidMount(){
		const id = this.props.location.state.id
	 	await this.getPlatfmcodeList(); 
        if( id!==null && id!==undefined){
            this.props.editB2bPlatform(id)
       }	
	}


 	getPlatfmcodeList = async () => {
	 const flag = await this.props.getPlatfmcodeList().then(res => {
			if (res && res.status === 'success' && res.data.length > 0) {
				this.setState({
					platformData: res.data,
				});
			}
			return 'success'
		})
		return flag
	}

    goBack = () => {
		this.props.history.push(`/b2bPlatformList`, {type: "list"})
	};

    goUpdate =()=>{
        const item = this.props.location.state.item
        this.props.history.push(`/addB2bPlatform/${ item.id }`, {item:item, type: "edit"});
    }

	
render() {
	const {platformEditList} =this.props
    const { platformData } =this.state
    let platformName=[];
    if(platformData.length>0){
        platformName = platformData.filter(item=>{if(platformEditList && platformEditList.platformCode){
			return item.key===platformEditList.platformCode
		}})
    } 
    let contactEmail =[]
    if(platformEditList && platformEditList.contactEmail && platformEditList.contactEmail.length>0){
        contactEmail = platformEditList.contactEmail.split(';')
    }

    
	let lang = loadLanguage();
	return (
		<div className='b2b-platform-save'>
			
			<Header hasUserCenter={ true } hasArrowBackIos={ true } backEvent={ this.goBack }>

				<Grid className='page-title-container no-margin' container spacing={0} justify={'space-evenly'}>
					<Grid className='page-title' item xs={11}>
						<span>{T('b2b_management_config')}</span>
					</Grid>
				</Grid>

			</Header>
			<div className="content">
				<section className="content-box b2b-management-basicselect">			
					<Grid container spacing={0} justify={'center'} className="transfer-to-container">
						<Grid item xs={12} className="b2b-platform-shipto">
                        	<label>{T('shipTo')}:</label>
							<p className='b2b-management-view-info'>{platformEditList && platformEditList.stNumber}</p>
						</Grid>
						<Grid item xs={12} className="b2b-platform-content">
                            <label>{T('order_subject')}:</label>
                            <p className='b2b-management-view-info'>{platformEditList && platformEditList.stAlpha}</p>                       
						</Grid>
						<Grid item xs={12} className="b2b-platform-content">
							<label>{T('backup_supply_center')}:</label>
							<p className='b2b-management-view-info'>{platformEditList && platformEditList.supplyCenterName}</p>  					
						</Grid>
						<Grid item xs={12} className="b2b-platform-content">
							<label>{T('b2b_management_platform')}:</label>
                            <p className='b2b-management-view-info'>{platformName.length>0 && platformName[0].value}</p> 			
						</Grid>
						{
							platformEditList && platformEditList.platformStCode && platformEditList.platformStCode.length>0 ?
							<Grid item xs={12} className="b2b-platform-content">
                        		<label>{T('platformShipto')}:</label>
								<p className='b2b-management-view-info'>{platformEditList && platformEditList.platformStCode}</p> 
							</Grid>:null
						}						
						<Grid item xs={12} className="b2b-platform-content">
                            <label>{T('b2b_management_use_wop')}:</label>
                            <p className='b2b-management-view-info'>{platformEditList && platformEditList.enableWop==='Y' ? T('b2b_management_use'):T('b2b_management_not_use')}</p> 
						</Grid>
						<Grid item xs={12} className="b2b-platform-content">
                            <label>{T('b2b_management_split_order_methods')}:</label>
                            <p className='b2b-management-view-info'>{platformEditList && platformEditList.splitByLine==='Y' ? T('b2b_management_supply_center_inventory_split_order'):T('b2b_management_customer_PO_number_split_order')}</p> 
						</Grid>
						{
							contactEmail.length>0 ?
							<Grid item xs={12} className="b2b-platform-content-email">
								<label>{T('email')}:</label>
								{
									contactEmail.length>0 && contactEmail.map(item=>{
										return (<p className='b2b-management-view-info'>{item}</p> )
									})
								}                       
							</Grid>:null
						}                      
						{
							platformEditList && platformEditList.description && platformEditList.description.length>0 ?
							<Grid item xs={12} className="b2b-platform-content-description">
                            	<label>{T('b2b_management_description')}:</label>
                            	<p className='b2b-management-view-info b2b-management-view-info-description'>{platformEditList && platformEditList.description}</p> 
							</Grid>:null
						}                       
					</Grid>

				</section>
			</div>

			<Grid className='confirm-select' container spacing={0} justify={'center'}>
				<Grid item xs={5}>
					<BasicButton className={util.getClassName({
                            "btn-width": true && lang !== 'EN',
                            "en-btn-width": true && lang === 'EN'}) } type="primary"  onClickOfSingleTap={this.goUpdate}>
						<span>{ T('b2b_management_update')}</span>
					</BasicButton>
				</Grid>
			</Grid>
		</div>
		);
	}
}

const mapStateToProps = state => {
	const { host, localData, userCenter, b2bManagement } = state;
	return {
		supplyCenterlist: host.supplyCenterlist,
		SCList: userCenter.SCList,
		platformList: b2bManagement.platformList,
		platformEditList:b2bManagement.platformEditList,
		skuVagueSearchData:host.skuVagueSearchData,
		supplyCenterAlllist: host.supplyCenterAlllist,
		localData: localData
	};
};

const mapDispatchToProps = {
	openNotification,
	getSCList,
	getEoneStList,
	getPlatfmcodeList,
	getStInforList,
	saveB2bPlatform,
	updateB2bPlatform,
	editB2bPlatform
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewB2bPlatform);
